<template>
  <div>
    <Hero kind="empty" />

    <ProjectHero />

    <ProjectDescription
      :active-tab="activeTab"
      @click="setActiveTab"
    />

    <div :class="$style.projectsNav">
      <router-link
        v-if="prevProject"
        :to="`/projects/${prevProject.slug}`">Предыдущий проект</router-link>
      <router-link
        v-if="nextProject"
        :to="`/projects/${nextProject.slug}`">Следующий проект</router-link>
    </div>

    <SideButton
      path-to="/projects"
      type="route">
      Назад к проектам
    </SideButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FETCH_PROJECT_BY_SLUG } from 'store/actions';
import { GET_PROJECT } from 'store/getters';
import Hero from 'components/Hero';
import SideButton from 'components/BaseSideButton';
import { projects } from '../data/mockProjects';

const ProjectHero = () => import('components/ProjectHero');
const ProjectDescription = () => import('components/ProjectDescription');

export default {
  name: 'Projects',
  components: {
    ProjectDescription,
    Hero,
    ProjectHero,
    SideButton,
  },
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'issue',
    };
  },
  computed: {
    ...mapGetters({
      project: GET_PROJECT,
    }),
    currentIndexBySlug() {
      return projects.findIndex(project => project.slug === this.slug);
    },
    prevProject() {
      return projects[this.currentIndexBySlug - 1] || null;
    },
    nextProject() {
      return projects[this.currentIndexBySlug + 1] || null;
    },
  },
  watch: {
    $route() {
      this.fetchProject();
    },
  },
  created() {
    this.fetchProject();
  },
  methods: {
    ...mapActions([FETCH_PROJECT_BY_SLUG]),
    fetchProject() {
      this[FETCH_PROJECT_BY_SLUG](this.slug).catch(() => {});
    },
    setActiveTab(value) {
      this.activeTab = value;
    },
    resetTab() {
      this.activeTab = 'issue';
    },
  },
};
</script>
<style lang="scss" module>
.projectsNav {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding-block: 20px 40px;

  a {
    font-size: 14px;
    line-height: 1.25rem;
    background: #fff;
    border-radius: 24px;
    border: 1px solid #e7e5e4ff;
    padding: 8px 16px;
    text-decoration: none;
    color: var(--color-black, #000);
    text-align: center;

    &:hover {
      cursor: pointer;
      filter: brightness(95%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Project.vue